module.exports = __webpack_public_path__ + "static/img/3areaB_12.5ad8256.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_12.png
// module id = 1163
// module chunks = 1